module.exports = __webpack_public_path__ + "static/media/EFX-2015.1be5656b.svg";